/**
 * Onthoudt de laatst-bezochte BTW Batterij URL (lijst of board, inclusief filters
 * in de query) zodat sidebar-klik terugbrengt naar wat je het laatst deed.
 *
 * Gebruikt localStorage + een custom event ("btw:lastUrl") voor same-tab updates
 * (de native `storage` event vuurt alleen cross-tab).
 */
const KEY = "btw:lastUrl";
// Default is de lijst (besluit eigenaar 2026-10-20); het board blijft
// bereikbaar via de lijst/board-schakelaar en wordt daarna onthouden.
const DEFAULT_URL = "/panel/admin/btw-batterij-overzicht";
const ALLOWED_PATHS = [
  "/panel/admin/btw-batterij-overzicht",
  "/panel/admin/btw-batterij-board",
];

const isAllowedPath = (path) =>
  ALLOWED_PATHS.some((p) => path === p || path.startsWith(`${p}?`));

export const saveBtwLastUrl = (pathname, search) => {
  if (typeof window === "undefined") return;
  if (!isAllowedPath(pathname)) return;
  const url = `${pathname}${search ?? ""}`;
  try {
    localStorage.setItem(KEY, url);
    window.dispatchEvent(new Event("btw:lastUrl"));
  } catch (_e) {
    // Storage kan disabled zijn (private mode, quota); skip stilletjes.
  }
};

export const loadBtwLastUrl = () => {
  if (typeof window === "undefined") return DEFAULT_URL;
  try {
    const v = localStorage.getItem(KEY);
    if (v && ALLOWED_PATHS.some((p) => v.startsWith(p))) return v;
  } catch (_e) {
    // localStorage kan disabled zijn; fallthrough naar default
  }
  return DEFAULT_URL;
};
